// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__2as7E","navLink":"tab_navLink__1VBT5","tabSelected":"tab_tabSelected__2QpFW","hidden":"tab_hidden__3ggji"};